<template>
  <div class="row w-100 m-0 app-container">
    <!-- <div class="toolbar"> -->
      <!-- <div class="sync-button" v-on:click="profileHelper.sync()">
        <i class="fas fa-sync-alt"></i>
      </div>
      <div class="toggle-menu-button" v-on:click="showMenu = !showMenu">
        <i v-show="showMenu" class="fas fa-bars"></i>
        <i v-show="!showMenu" class="fas fa-angle-double-right"></i>
      </div> -->
    <!-- </div> -->

    <div class="code-generator-container">
      <h2 class="primary header">Create profile code</h2>
      <i class="profile-icon primary far fa-user"></i>
      <!-- <div class="code-result primary header">Code:</div> -->
      <div v-clipboard="codeFromUrl" class="code-result primary header"><i class="far fa-clipboard code-copy-button" v-if="codeFromUrl" ></i>{{codeFromUrl}}</div>
      <div class="code-generator-button subheader primary" v-on:click="getCode()">
        GENERATE
      </div>
    </div>

    <div class="app-footer"></div>
    <LoaderComponent :loading="loading" />
  </div>
</template>

<script>
import Configuration from "../helpers/Configuration.js";
import CodeHelper from "../helpers/CodeHelper.js";
import LoaderComponent from "./LoaderComponent.vue";


export default {
  name: "AppComponent",
  components: {
    LoaderComponent
  },
  props: {},
  data: function () {
    return {
      configuration: {},
      codeHelper: {},
      profileHelper: {
        profile: {},
      },
      showSkills: false,
      showIntroduction: true,
      showMenu: true,
      title: "> Initialised",
      loading: false,
    };
  },
  computed: {
    codeFromUrl: function() {
      let result = window.location.toString().replace("#", "&");
  
        const split = result.split("?")[1];
  
        let urlParams = new URLSearchParams(split);
  
        const token = urlParams.get("access_token");

        console.log(token);

        return token;
    }
  },
  methods: {
    getCode: function() {
      this.codeHelper.getCode();
    },
    loadingStart: function () {
      this.loading = true;
    },
    loadingEnd: function () {
      this.loading = false;
    },
  },
  mounted: function () {
    this.configuration = new Configuration(process.env);
    this.codeHelper = new CodeHelper(this.configuration, null);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.app-container {
  height: 100%;
}

.toolbar {
  background-color: #212121;
  position: fixed;
  top: 0;
  display: inline-block;
  height: 4rem;
  z-index: 1;
  width: 100%;
}

.code-generator-container {
  border-style: solid;
    border-width: 1px;
    border-color: #ffc107;
    padding:2rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
    width:100%;
    height:100%;
    text-align:center;
}

.code-result {
    margin-left: auto;
    margin-right: auto;
    height: 2rem;
    line-height: 2rem;
    padding-top: 2rem;
    font-size:0.75rem;
    padding-bottom: 2rem;
    cursor: pointer;
}

.code-generator-button {
  user-select:none;
   border-style: solid;
    border-width: 1px;
    border-color: #ffc107;
    margin-left: auto;
    margin-right: auto;
    width: 15rem;
    margin-top: 2rem;
    padding:2rem;
}

.code-generator-button:hover {
  background-color: #ffc107;
  color: black;
  cursor:pointer;
}

.code-copy-button {
  margin-right: 10px;
  cursor: pointer;
}

.profile-icon {
      margin-top: 2rem;
    font-size: 12rem;
    margin-left: auto;
    margin-right: auto;
}

.login-button {
  padding: 5px;
  margin: 50px;
  width: 100px;
}

.logo {
  width: 5rem;
}

.header {
  font-family: "Quantico", sans-serif !important;
  text-transform: uppercase;
}

.subheader {
  font-family: "Quantico", sans-serif !important;
}

.primary {
  color: #ffc107;
}

.secondary {
  color: #00bcd4;
}

.tertiary {
  color: #f44336;
}

.bg-grey {
  background-color: #212121;
}

.grey-panel {
  background-color: #212121;
  padding-top: 4rem;
}

.grey-panel-hidden {
  background-color: #1a1a1b;
  padding-top: 4rem;
}

.link {
  color: #ff9800;
  font-weight: bold;
  transition: all 0.2s;
}

.link:hover {
  color: #ffc107;
  text-decoration: none;
}

.shadow {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.sync-button {
  cursor: pointer;
  position: fixed;
  top: 1rem;
  right: 0px;
  background-color: #ffc107;
  color: #1a1a1b;
  width: 3rem;
  height: 2rem;
  line-height: 2rem;
  transition: all 0.2s;
  z-index: 99;
  text-align: center;
  border-radius: 5px 0 0 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

@media screen and (min-width: 992px) {
  .toolbar {
    background: 0;
  }

  .code-generator-container {
    width: 50%;
    margin-top:2rem;
    margin-bottom:2rem;
    height:auto;
  }

  .code-generator-button {
    margin-top: 9rem;
  }

  .code-result {
    font-size:1rem;
}

  .profile-icon {
  margin-top: 9rem;
  }
}
</style>


    <!-- <div
      class="col-lg-2"
      v-bind:class="{ 'grey-panel': showMenu, 'grey-panel-hidden': !showMenu }"
    >
      <transition name="fade">
        <ProfileComponent :profile="profileHelper.profile" v-show="showMenu" />
      </transition>
      <MenuComponent
        v-show="showMenu"
        @toggleSkills="showSkills = !showSkills"
        @selectIntroduction="selectIntroduction"
        :showSkills="showSkills"
      />
    </div> -->
    <!-- <div class="col-lg-9">
      <div class="pt-4 pr-md-5 pl-md-5">
        <transition name="fade">
          <IntroductionComponent
            @loadingStart="loadingStart"
            @loadingEnd="loadingEnd"
            @milestoneReached="milestoneReached"
            v-if="showIntroduction"
            :profile="profileHelper.profile"
          />
        </transition>
        <SkillsComponent
          :skills="profileHelper.profile.skills"
          :showSkills="showSkills"
        />
      </div>
    </div> -->
    <!-- <div
      class="col col-lg-2 col-xl-1 text-center"
      v-bind:class="{ 'grey-panel': showMenu, 'grey-panel-hidden': !showMenu }"
    >
      <transition name="fade">
        <div v-show="showMenu">
          <img class="logo" alt="Logo" src="../assets/logo.png" />
          <h6 class="header mt-3 primary">SWC - STORIES</h6>
          <p>
            A collection of short scenarios in the style of a
            choose-your-own-adventure, using player data from
            <a
              class="link"
              href="https://www.swcombine.com/"
              target="_blank"
              rel="noopener noreferrer"
              >Star Wars Combine</a
            >
          </p>
          <p>
            This application is currently under
            <span class="fw-b">development</span>. If you have any queries
            regarding its function, please contact the developer
            <a class="link" href="mailto:iok.verlaran@gmail.com">here</a>.
          </p>
        </div>
      </transition>
    </div> -->